<template>
  <div class="classify">
    <van-popup :value="classify"
               :close-on-click-overlay="close_overlay">
      <div class="class_content">
        <header>选择分类</header>
        <span v-for="(item,index) in list"
              @click="setClassify(item)"
              :key="index">{{item.title}}</span>
      </div>
    </van-popup>
  </div>
</template>

<script>
import store from '../store'
import { mapState } from "vuex";
export default {
  data () {
    return {
      show: store.state.classify_id,
      list: [],
    };
  },
  props: {
    close_overlay: {
      type: Boolean,
      default () {
        return false
      }
    }
  },
  computed: mapState(["classify"]),
  methods: {
    getClassify () {
      this.$http.get(`/api/app/comment/classify`).then((res) => {
        this.list = res;
      });
    },
    async setClassify (item) {
      if (item.id == localStorage.classify_id) {//如果选当前分类，不做操作
        this.$store.commit('SET_CLASSIFY', false);
        return;
      } else {
        localStorage.setItem('classify_id', item.id);
        localStorage.setItem('classify_name', item.title);
        await this.$store.commit('SET_CLASSIFY', false);
        if (localStorage.adminToken) {
          await this.$store.dispatch("getPerson");
          await this.$pub.setClassify();
        }
        this.$router.go(0);
      }

    }
  },
  created () {
    this.getClassify();
  }
};
</script>
<style lang="scss" scoped>
.classify {
  /deep/ {
    .van-overlay {
      z-index: 10001 !important;
    }
    .van-popup--center {
      border-radius: 20px;
      z-index: 10002 !important;
    }
  }
  .class_content {
    width: 690px;
    padding: 55px;
    text-align: center;
    padding: 55px 0;
    header {
      font-size: 32px;
      text-align: center;
      margin-bottom: 65px;
    }
    span {
      font-size: 24px;
      width: 186px;
      height: 53px;
      line-height: 53px;
      padding: 10px 0;
      display: inline-block;
      background-color: #f5f5f5;
      color: #666666;
      margin-top: 21px;
      border-radius: 4px;
      &:nth-child(3n) {
        margin: 0 21px;
      }
      @include eps;
    }
  }
}
</style>

